import { addBreadcrumb } from '@sentry/react';
import type { PaymentMethodSetupEvent } from '@frontend/payments-platform';
import type { PaymentFieldType } from './payment-field.helpers';

const CATEGORY = 'digital-forms.payment-field';

export type PaymentFieldEvent = PaymentMethodSetupEvent | 'modal_opened';

/**
 * Payment field breadcrumbs (spec §B12). Only outcome categories, error codes and counts are recorded — never
 * billing details, names, client secrets or masked card data.
 */
export const trackPaymentFieldEvent = (
  event: PaymentFieldEvent,
  fieldType: PaymentFieldType,
  data?: Record<string, string | number | boolean | undefined>,
  level: 'info' | 'warning' = 'info'
) => {
  addBreadcrumb({ category: CATEGORY, message: `payment_field.${event}`, level, data: { fieldType, ...data } });
};
